import { denormalize } from "@/helpers/JsonApiDenormalizer";
import { MissionService } from "@/services/mission.service";

const missions = {
  namespaced: true,
  state: {
    recently_updated: [], // last few updated missions
    selected: null,
  },
  mutations: {
    SET_MISSION_UPDATED(state, mission) {
      let missions = state.recently_updated.filter(m => {
        return m.id != mission.id;
      });
      missions = missions.slice(-9);
      missions.push(mission);
      state.recently_updated = missions;
    },
    SET_SELECTED(state, mission) {
      state.selected = mission;
    }
  },
  actions: {
    async setMissionUpdated({ commit }, mission_id) {
      const mission = await MissionService.find(mission_id).then(response => {
        return denormalize(response.data);
      })
      .catch(err => {
        console.log('vuex::missions@setMissionUpdated');
        console.log(err);
      });

      commit('SET_MISSION_UPDATED', mission);
    }
  },
  getters: {
    /*
    hasPermission: (state) => (permission) => {
      const permissions = state.user.permissions || [];
      return permissions.findIndex((p) => p.name === permission) > -1;
    },
    */
  },
};

export default missions;
